import * as React from 'react';

import { type WrappedFieldProps } from 'redux-form';

import Radio, { type OwnFieldProps as RadioProps } from './Radio';

const RadioField = (props: RadioProps & WrappedFieldProps) => {
  const { hideErrors, input, meta, ...selectProps } = props;

  const errorMessage = !hideErrors && meta && meta.touched && meta.error ? meta.error : null;

  return (
    <Radio
      name={input.name}
      onChange={input.onChange}
      value={input.value}
      {...selectProps}
      errorMessage={errorMessage}
    />
  );
};

const ComposedRadioField = React.memo(RadioField);

export default ComposedRadioField;
